<template>
	<div class="section" v-bind="$props">
		<slot />
	</div>
</template>
<script lang="ts">
import { defineComponent, PropType } from "vue";

const PADDING = ["top", "bottom", "vertical", "horizontal", "all", "none"] as const;

export type SectionPadding = typeof PADDING[number];
/**
 * Section wrapper is used to group the related content together to form a section in slide-out.
 */
export default defineComponent({
	name: "Section",
	props: {
		/**
		 * 'top' | 'bottom' | 'vertical' | 'horizontal' | 'all' | 'none'
		 */
		padding: {
			type: String as PropType<SectionPadding>,
			default: "all",
			validator(value: SectionPadding) {
				return PADDING.includes(value);
			}
		},

		/**
		 * true | false
		 */
		disabled: {
			type: Boolean,
			default: false
		}
	}
});
</script>
<style lang="scss">
$padding: 24px;
.section {
	width: 100%;

	&[padding="vertical"] {
		padding-left: $padding;
		padding-right: $padding;
	}

	&[padding="horizontal"] {
		padding-top: $padding;
		padding-bottom: $padding;
	}

	&[padding="all"] {
		padding: $padding;
	}
	&[padding="top"] {
		padding-top: $padding;
	}
	&[padding="bottom"] {
		padding-bottom: $padding;
	}

	&[disabled] {
		filter: opacity(0.3);
		cursor: not-allowed;
		pointer-events: none;
	}
}
</style>
